import { getBrowserAndOSInfo } from "@/utils";

export function addToGoogleCalendarToAndroid(eventData) {
  const { name, date_init, date_end, description, address } = eventData;

  const formatDateForCalendar = (date) => date.replace(/[-:]/g, "").replace(".000", "");

  const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    name || ""
  )}&dates=${encodeURIComponent(
    formatDateForCalendar(date_init)
  )}/${encodeURIComponent(
    formatDateForCalendar(date_end)
  )}&details=${encodeURIComponent(
    description || ""
  )}&location=${encodeURIComponent(
    address?.street || ""
  )}`;

  const intentUrl = `intent:${googleCalendarUrl}#Intent;scheme=https;package=com.google.android.calendar;end;`;

  // Open the intent URL
  window.location.href = intentUrl;
}

export function addToOutlookCalendar(eventData) {
  const { os } = getBrowserAndOSInfo();

  if (os === "Android") {
    return addToGoogleCalendarToAndroid(eventData);
  }

  const { name, date_init, date_end, description, address } = eventData;

  const outlookCalendarUrl = `https://outlook.live.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(
    name
  )}&startdt=${encodeURIComponent(
    date_init
  )}&enddt=${encodeURIComponent(
    date_end
  )}&body=${encodeURIComponent(
    description
  )}&location=${encodeURIComponent(
    address?.street
  )}`;

  window.open(outlookCalendarUrl, "_blank");
}

export function addToGoogleCalendar(eventData) {
  const { name, date_init, date_end, description, address } = eventData;

  const googleCalendarUrl = `https://calendar.google.com/calendar/u/0/r/eventedit?text=${encodeURIComponent(
    name
  )}&dates=${encodeURIComponent(
    date_init?.replace(/[-:]/g, "")
  )}/${encodeURIComponent(
    date_end?.replace(/[-:]/g, "")
  )}&details=${encodeURIComponent(
    description
  )}&location=${encodeURIComponent(
    address?.street
  )}`;

  window.open(googleCalendarUrl, "_blank");
}
